import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterToggle',
  props: {
    value: null,
    header: null,
    headerClass: null,
    options: null,
    mobileOnTop: { type: Boolean }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: any): void, (e: 'change', value: any): void}), expose: any, slots: any, attrs: any }) {





const borderColor = computed<OpacityFunction>(() => store.getters['app/borderColor']);
const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);

const fixedButtonStyling = 'u-py-2 lg:u-pt-0 lg:u-px-3 u-min-w-80p lg:u-min-w-[57px] lg:u-text-center lg:u-border-b';
const regularButtonStyling = 'u-pb-2 u-px-3 md:u-min-w-[57px] u-text-center u-border-b';

function toggle(value: any) {
    emit('input', value);
    emit('change', value);
}


return { __sfc: true,emit, borderColor, textColor, fixedButtonStyling, regularButtonStyling, toggle }
}

})